import { useEffect, useRef } from 'react';

/**
 * Confirmation for destructive actions.
 *
 * A component rather than window.confirm() so the prompt is Arabic, right to
 * left, and consistent with the rest of the interface — and so the confirming
 * button can be styled as the destructive one.
 */
export default function ConfirmDialog({
  title,
  message,
  detail,
  confirmLabel = 'تأكيد',
  cancelLabel = 'تراجع',
  busy = false,
  onConfirm,
  onCancel,
}) {
  const cancelRef = useRef(null);

  // Focus lands on the safe choice, so a stray Enter does not delete anything.
  useEffect(() => {
    cancelRef.current?.focus();
  }, []);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === 'Escape' && !busy) onCancel();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCancel, busy]);

  return (
    <div
      className="modal-overlay"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !busy) onCancel();
      }}
    >
      <div
        className="modal"
        style={{ maxWidth: '430px' }}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
      >
        <div className="modal-header">
          <h2 id="confirm-title">{title}</h2>
        </div>

        <div className="modal-body">
          <p style={{ margin: 0 }}>{message}</p>
          {detail && (
            <p className="hint" style={{ marginTop: '8px' }}>
              {detail}
            </p>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn"
            onClick={onCancel}
            disabled={busy}
            ref={cancelRef}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? '...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
